<template>
  <g>
   <line
      v-bind="position"
      :id="data.id"
      :stroke="color"
      stroke-linecap="round"
      stroke-width="6"
      class="wire-border"
    ></line>
   <line
      v-bind="position"
      :id="data.id"
      :stroke="color"
      stroke-linecap="round"
      stroke-width="3"
      class="wire"
    ></line>
  </g>
</template>

<script>
export default {
  name: 'Wire',
  props: ['data'],
  computed: {
    color () {
      return this.data.color ? this.data.color : 'rgb(0,128,0)'
    },
    position () {
      return {
        x1: this.data.points[0].x,
        y1: this.data.points[0].y,
        x2: this.data.points[1].x,
        y2: this.data.points[1].y
      }
    }
  }
}
</script>

<style lang="scss" scoped>
g:hover{
  line.wire{
    cursor: pointer;
  }
}
g.selected{
  line.wire-border{
    stroke: #fc5858 !important;
  }
}
</style>
